// TODO: Update this when we need to support a stock not traded in USD:
export const useGetStockCurrencyCode = () => 'USD';
